import React, { useState } from 'react';
import { FiMail, FiUser, FiPhone, FiMessageSquare, FiSend } from 'react-icons/fi';
import { contactAPI } from '../services/api';
import { toast } from 'react-toastify';

const ContactPage = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim() || !form.message.trim()) {
      toast.error('Please fill in all required fields');
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await contactAPI.submit(form);
      if (data.success) {
        setSubmitted(true);
        toast.success(data.message || 'Message sent!');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to send message. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="page-container" style={{ maxWidth: 700, margin: '0 auto', padding: '40px 16px 60px' }}>
      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: 40 }}>
        <div style={{ fontSize: '3rem', marginBottom: 12 }}>📬</div>
        <h1 style={{ color: 'var(--text-heading)', marginBottom: 8, fontSize: '2rem' }}>Contact Us</h1>
        <p style={{ color: 'var(--text-light)', fontSize: '1rem', maxWidth: 500, margin: '0 auto' }}>
          Have a suggestion, feedback, or want to know more about our pickles? We'd love to hear from you!
        </p>
      </div>

      {/* Contact Info Strip */}
      <div style={{
        display: 'flex', flexWrap: 'wrap', gap: 16, marginBottom: 36,
        justifyContent: 'center',
      }}>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 10, padding: '12px 20px',
          background: 'var(--bg-muted)', borderRadius: 'var(--radius-pill)',
          border: '1px solid var(--border-light)', fontSize: '0.88rem', color: 'var(--text-medium)',
        }}>
          <FiMail size={16} color="var(--primary)" />
          <span>swaadpickles92@gmail.com</span>
        </div>
        <div style={{
          display: 'flex', alignItems: 'center', gap: 10, padding: '12px 20px',
          background: 'var(--bg-muted)', borderRadius: 'var(--radius-pill)',
          border: '1px solid var(--border-light)', fontSize: '0.88rem', color: 'var(--text-medium)',
        }}>
          <span>Homemade with love by - Manisha Suthar</span>
        </div>
      </div>

      {/* Form / Success State */}
      {submitted ? (
        <div style={{
          background: 'white', borderRadius: 'var(--radius-lg)', padding: 40,
          textAlign: 'center', border: '2px solid #4CAF50', boxShadow: 'var(--shadow-sm)',
        }}>
          <div style={{ fontSize: '3.5rem', marginBottom: 16 }}>🎉</div>
          <h2 style={{ color: '#2E7D32', marginBottom: 12 }}>Message Sent!</h2>
          <p style={{ color: '#666', marginBottom: 24 }}>
            Thank you for reaching out. We'll get back to you as soon as possible!
          </p>
          <button
            className="btn btn-primary"
            onClick={() => { setSubmitted(false); setForm({ name: '', email: '', phone: '', message: '' }); }}
          >
            Send Another Message
          </button>
        </div>
      ) : (
        <form
          onSubmit={handleSubmit}
          style={{
            background: 'white', borderRadius: 'var(--radius-lg)', padding: '36px 32px',
            boxShadow: 'var(--shadow-sm)', border: '1px solid var(--border-light)',
          }}
        >
          <div className="form-row">
            <div className="form-group">
              <label>
                <FiUser size={13} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                Your Name <span style={{ color: 'var(--primary)' }}>*</span>
              </label>
              <input
                type="text"
                name="name"
                placeholder="e.g. Priya Sharma"
                value={form.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>
                <FiMail size={13} style={{ marginRight: 6, verticalAlign: 'middle' }} />
                Email Address <span style={{ color: 'var(--primary)' }}>*</span>
              </label>
              <input
                type="email"
                name="email"
                placeholder="you@example.com"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>
              <FiPhone size={13} style={{ marginRight: 6, verticalAlign: 'middle' }} />
              Phone Number <span style={{ color: '#aaa', fontWeight: 400 }}>(optional)</span>
            </label>
            <input
              type="tel"
              name="phone"
              placeholder="+91 98765 43210"
              value={form.phone}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>
              <FiMessageSquare size={13} style={{ marginRight: 6, verticalAlign: 'middle' }} />
              Your Message <span style={{ color: 'var(--primary)' }}>*</span>
            </label>
            <textarea
              name="message"
              rows={5}
              placeholder="Share your suggestions, feedback, or questions about our pickles..."
              value={form.message}
              onChange={handleChange}
              required
              style={{ resize: 'vertical', fontFamily: 'inherit' }}
            />
          </div>

          <button
            type="submit"
            className={`btn btn-primary ${submitting ? 'btn-disabled' : ''}`}
            style={{ width: '100%', marginTop: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
            disabled={submitting}
          >
            {submitting ? (
              <>⏳ Sending...</>
            ) : (
              <><FiSend size={15} /> Send Message</>
            )}
          </button>

          <p style={{ marginTop: 16, textAlign: 'center', fontSize: '0.78rem', color: 'var(--text-muted)' }}>
            We typically respond within 24-48 hours. 🙏
          </p>
        </form>
      )}
    </div>
  );
};

export default ContactPage;
